import AddinActivator from './AddinActivator';
import enableAddinCommands from './enableAddinCommands';
import ExtensibilityContext from 'owa-service/lib/contract/ExtensibilityContext';
import Extension from 'owa-service/lib/contract/Extension';
import loadExtensibilityContext from './loadExtensibilityContext';
import { isAddinComplianceVerificationEnabled } from 'owa-addins-feature-flags';
import {
    AddinCommandFactory,
    AddinFactory,
    setExtensibilityContext,
    setExtensibilityStateIsDirty,
    isExtensibilityContextInitialized,
    isExtensibilityStateDirty,
    whenExtensibilityContextInitialized,
    setCompliance,
    getExtensibilityContext,
} from 'owa-addins-store';
import { trace } from 'owa-trace';

let isInLoading = false;

function getEnabledAddins(context: ExtensibilityContext): Extension[] {
    return context && context.Extensions
        ? context.Extensions.filter(extension => {
              return extension.Enabled && extension.ExtensionPointCollection != null;
          })
        : [];
}

export default function initializeExtensibilityContext(): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
        if ((isLoading() || isExtensibilityContextInitialized()) && !isExtensibilityStateDirty()) {
            whenExtensibilityContextInitialized(resolve);
            return;
        }

        setExtensibilityStateIsDirty(false);
        setLoading(true);
        let enabledAddins = [];
        const addinActivator = new AddinActivator(new AddinFactory(new AddinCommandFactory()));
        let context: ExtensibilityContext = null;
        try {
            context = await loadExtensibilityContext();
        } catch (error) {
            trace.error(error);
        }
        setExtensibilityContext(context);
        context = getExtensibilityContext();
        if (isAddinComplianceVerificationEnabled()) {
            setCompliance(context.GenericInfo);
        }
        enabledAddins = getEnabledAddins(context);

        await enableAddinCommands(enabledAddins, addinActivator);
        setLoading(false);
        resolve();
    });
}

export function setLoading(isLoading: boolean): void {
    isInLoading = isLoading;
}

export function isLoading(): boolean {
    return isInLoading;
}
